import { ReactNode } from "react";
import { Paper, Text } from "$components";
import useJStyles from "$hooks/useJStyles";

type Props = {
  children: ReactNode;
  id?: string;
  title?: string;
};

function Block({ children, id, title }: Props) {
  const { jclasses } = useJStyles();
  return (
    <Paper className={jclasses.jPaper} style={{ overflowY: "initial" }}>
      {title && (
        <Text id={id} type="h2" style={{ marginTop: 0 }}>
          {title}
        </Text>
      )}
      {children}
    </Paper>
  );
}

export default Block;
